import { useEffect, useState } from "react";

const HIDDEN_CLASS = "is-tab-hidden";
const ENABLED = process.env.REACT_APP_PAUSE_BACKGROUND_TABS !== "false";

const listeners = new Set();
let started = false;

const readVisible = () => !ENABLED || typeof document === "undefined" || document.visibilityState !== "hidden";

const broadcast = () => {
  const visible = readVisible();
  document.documentElement.classList.toggle(HIDDEN_CLASS, !visible);
  listeners.forEach((listener) => {
    try {
      listener(visible);
    } catch (error) {
      console.error("pageVisibility", error);
    }
  });
};

const start = () => {
  if (started || !ENABLED || typeof document === "undefined") return;
  started = true;
  document.addEventListener("visibilitychange", broadcast);
  broadcast();
};

export const isPageVisible = readVisible;

export const onVisibilityChange = (listener) => {
  start();
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const usePageVisible = () => {
  const [visible, setVisible] = useState(readVisible);
  useEffect(() => onVisibilityChange(setVisible), []);
  return visible;
};
